// extracted by mini-css-extract-plugin
export default {"badge":"GlutenFree_badge__suxCt","vegan-active":"GlutenFree_vegan-active__eVLmP","vegetarian-active":"GlutenFree_vegetarian-active__+GsRA"};